<template>
  <div class="w-full d-flex flex-column pa-3">
    <OAlert class="w-full" info v-if="isRoot">
      Este perfil é root, logo possui todas as permissões.
    </OAlert>

    <div v-else class="w-full d-flex">
      <div class="w-1/2 d-flex flex-column">
        <div class="d-flex my-1" v-for="p in perm0" :key="p.code">
          <v-icon small class="w-50">
            {{ has(p) ? 'mdi-check-bold' : 'mdi-block-helper' }}
          </v-icon>
          <span :class="{ 'font-weight-bold': has(p) }">{{ p.label }}</span>
        </div>
      </div>
      <div class="w-1/2 d-flex flex-column">
        <div class="d-flex my-1" v-for="p in perm1" :key="p.code">
          <v-icon small class="w-50">
            {{ has(p) ? 'mdi-check-bold' : 'mdi-block-helper' }}
          </v-icon>
          <span :class="{ 'font-weight-bold': has(p) }">{{ p.label }}</span>
        </div>
      </div>
    </div>

    <div class="pa-3 mt-8">
      <v-btn large color="primary" @click="edit">Editar</v-btn>
    </div>

    <ODialog ref="dialog" :maxWidth="600">
      <v-card>
        <ODialogBar title="Editar Permissões" @close="dismiss" />
        <v-card-text class="d-flex flex-wrap pa-3">
          <div class="w-1/2 d-flex flex-column">
            <v-switch
              v-for="p in perm0"
              :key="p.code"
              class="ma-0 pa-0 mb-1"
              dense
              inset
              hide-details
              single-line
              v-model="clonedValues[p.code]"
              :label="p.label"
            />
          </div>
          <div class="w-1/2 d-flex flex-column">
            <v-switch
              v-for="p in perm1"
              :key="p.code"
              class="ma-0 pa-0 mb-1"
              dense
              inset
              hide-details
              single-line
              v-model="clonedValues[p.code]"
              :label="p.label"
            />
          </div>
        </v-card-text>
        <ODialogButtons
          class="pa-6"
          @apply="apply"
          @cancel="dismiss"
          txtApply="Salvar"
        />
      </v-card>
    </ODialog>
  </div>
</template>

<script>
import { OrgApi } from '@/models/index.js'

const allPermissions = [
  { code: 'canEditVehicles', label: 'Editar Veículos' },
  { code: 'canEditDrivers', label: 'Editar Motoristas' },
  { code: 'canReactivateDrivers', label: 'Reativar Motoristas' },
  { code: 'canEditOccurs', label: 'Editar Ocorrências' },
  { code: 'canEditOccurDigests', label: 'Editar Email de Ocorr.' },
  { code: 'canEditEIs', label: 'Editar IEs' },
  { code: 'canEditPolys', label: 'Editar Polígonos' },
  { code: 'canEditOverlays', label: 'Editar Overlays' },
  { code: 'canUnlockVehicle', label: 'Liberar partida' },
  { code: 'canEditTempPolys', label: 'Editar Polígonos Provisórios' },
  { code: 'canResetWorkshifts', label: 'Liberar jornada' },
  { code: 'canUnlockAxis', label: 'Liberar 5ª Roda' },
  // {code: 'canToggleCargo'     , label: 'Mudar flag carregado'},
  { code: 'canSetRankingGoal', label: 'Definir meta (ranking)' },
  { code: 'canCreateCards', label: 'Criar novos crachás' },
  { code: 'seeWorklogReports', label: 'Parte Diária/Ciclos' },
  { code: 'canPatchHosLawShifts', label: 'Editar jornada-lei' },
  { code: 'canEditShifts', label: 'Editar turnos' },
  { code: 'canEditMaintConfigs', label: 'Editar Conf. Manutenções' },
  { code: 'canEditRoutes', label: 'Editar Rotas' },
  { code: 'canEditRomaneios', label: 'Editar Romaneios' },
  { code: 'canSeeDmsEvents', label: 'Ver Eventos de Fadiga' },
  { code: 'canEditDmsEvents', label: 'Verificar/Descartar eventos de Fadiga' },
  { code: 'canSeeCameraFiles', label: 'Ver Câmera do Veículo' },
  { code: 'canSeeChecklists', label: 'Ver Checklists' }
]

const perm0 = allPermissions.slice(0, Math.ceil(allPermissions.length / 2))
const perm1 = allPermissions.slice(Math.ceil(allPermissions.length / 2))

export default {
  props: {
    value: { required: true },
    isRoot: { type: Boolean, default: false }
  },
  data() {
    return { allPermissions, perm0, perm1, clonedValues: {} }
  },
  methods: {
    has(perm) {
      return this.value.permissions[perm.code]
    },
    async edit() {
      this.clonedValues = JSON.parse(JSON.stringify(this.value.permissions))
      await this.$refs.dialog.$open()
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    apply() {
      this.dismiss()
      this.$rootLoading(async () => {
        let fetcher = new OrgApi(this.value.orgId)
        let old = await fetcher.get(`profiles/${this.value.id}`)
        Object.assign(old.permissions, this.clonedValues)
        await fetcher.put(`profiles/${this.value.id}`, old)
        this.$snack('Salvo com sucesso')
        this.$emit('reload')
      })
    }
  }
}
</script>
